import Cookies from 'js-cookie'

const getStoreName = (): string => {
  return Cookies.get('storeName') || ''
}

export default getStoreName
